/* Olympian Sports - theme scripts: sticky header shadow, product tabs, carousels, WhatsApp button */
(function () {
  'use strict';
  var d = document;

  function ready(fn) { d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }

  function initHeader() {
    var on = false;
    function check() {
      var s = window.scrollY > 8;
      if (s !== on) { on = s; d.documentElement.classList.toggle('ol-scrolled', s); }
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
  }

  function initCarousels(root) {
    (root || d).querySelectorAll('[data-ol-carousel]').forEach(function (c) {
      if (c.dataset.olInit) return;
      c.dataset.olInit = '1';
      var track = c.querySelector('[data-ol-track]');
      var prev = c.querySelector('[data-ol-prev]');
      var next = c.querySelector('[data-ol-next]');
      if (!track || !prev || !next) return;
      function update() {
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }
      function move(dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      c.addEventListener('ol:refresh', update);
      update();
    });
  }

  function initTabs(root) {
    (root || d).querySelectorAll('[data-ol-tabs]').forEach(function (wrap) {
      if (wrap.dataset.olInit) return;
      wrap.dataset.olInit = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = d.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (on && panel) {
            panel.querySelectorAll('[data-ol-carousel]').forEach(function (c) {
              c.dispatchEvent(new CustomEvent('ol:refresh'));
            });
          }
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); activate(n, true); }
        });
      });
    });
  }

  function initWhatsApp() {
    var a = d.querySelector('[data-ol-wa]');
    if (!a) return;
    function build() {
      var product = a.getAttribute('data-product');
      var msg = 'Hi Olympian Sports, I need some help' +
        (product ? ' with ' + product + ' (' + location.href + ')' : '') + '.';
      a.href = 'https://wa.me/' + a.getAttribute('data-number') + '?text=' + encodeURIComponent(msg);
    }
    build();
    a.addEventListener('click', build);
  }

  ready(function () {
    initHeader();
    initTabs();
    initCarousels();
    initWhatsApp();
  });

  // Keep sections working inside the Shopify theme editor
  d.addEventListener('shopify:section:load', function (e) {
    initTabs(e.target);
    initCarousels(e.target);
  });
})();
